/**
 * Host and co-host invitation for web streaming.
 */
export const INVITATION_URL_QUERY_KEY = 'fwinvite'
export const INVITATION_TOKEN_KEY = 'invitation_token'
export const INVITATION_TYPE_KEY = 'invitation_type'
export const INVITATION_LIVE_STREAM_ID_KEY = 'live_stream_id'

/**
 * Reasons for toggling a user's active watch status.
 * Values should be descriptive and human readable, they are used in logging.
 */
export enum ToggleUserActiveReason {
  GATE_UNLOCKED = 'gate unlocked',
  PLAYER_CLOSED = 'player closed',
  WATCH_VIDEO_CLICKED = '"watch video" thumbnail CTA clicked',
  HAS_SHARE_LINK = 'entered via share link',
  TAP_TO_WATCH_FALSE = 'params.tap_to_watch === false',
  PROGRAMMATIC_PLAYER_MAXIMIZED = 'programmatic player was maximized',
  UNLOCKED_THUMBNAIL_CLICKED = 'grid thumbnail clicked on video without access code',
  MORE_MENU_BUTTON_CLICKED = 'more menu button clicked',
  FULLSCREEN_BUTTON_CLICKED = 'fullscreen button clicked',
  VIDEO_CLICKED = 'video clicked',
  TIMELINE_SEEKED = 'timeline seeked',
  CLOSED_CAPTIONING_CLICKED = 'closed captioning button clicked',
  AUDIO_DESCRIPTION_CLICKED = 'audio description button clicked',
  TAP_TO_UNMUTE_CLICKED = 'tap to unmute clicked',
  TAP_TO_WATCH_CLICKED = 'tap to watch / tap to enter clicked',
  UNMUTE_CLICKED = 'unmute button clicked',
  SHOPPING_BAG_CLICKED = 'shopping bag button clicked',
  PLAY_CLICKED = 'play button clicked',
  INVITATION_ACCEPTED = 'guest speaker invitation accepted',
  SHARE_BUTTON_CLICKED = 'share button clicked',
}
